<template>
  <div
    class="forgot-page container"
    data-test="page-forgot">
    <h4 class="t-c m-b font-normal">Reset Password</h4>
    <p class="t-c m-b-2">Enter your email address and we’ll send you a link to reset your password</p>
    <el-form
      ref="forgotForm"
      :model="user"
      :rules="rules"
      :status-icon="true"
      @submit.native.prevent="onSubmit">
      <el-form-item
        prop="email"
        label="Email address">
        <el-input
          v-model.trim="user.email"
          placeholder="Email address"
          data-test="input-email"
          @keyup.native="checkValidation"/>
      </el-form-item>
      <div class="t-c m-t-2 action-buttons">
        <el-button
          v-loading="loading"
          :disabled="!form_valid"
          class="button large"
          type="primary"
          data-test="btn-reset"
          @click="onSubmit">Reset Password</el-button>
      </div>
      <div class="t-c m-t-2">
        <p>Already have an account? &nbsp;<router-link
          to="/signin"
          data-test="link-login">Log In</router-link></p>
      </div>
    </el-form>
  </div>
</template>

<script>
import User from '../../services/User';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'ForgotPassword',
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'Forgor Password',
      userProvider: null,
      user: {
        email: '',
      },
      rules: {
        email: [{ required: true, message: 'Email is Required', trigger: 'blur' },
          { type: 'email', message: 'Invalid Email Format', trigger: 'blur' }],
      },
      loading: false,
      form_valid: false,
    };
  },
  mounted() {
    this.userProvider = new User();
    window.eventBus.$emit('onboarding-step-change', -1);
  },
  methods: {
    onSubmit() {
      const ctx = this;
      this.$refs.forgotForm.validate((valid) => {
        this.form_valid = valid;
        if (valid) {
          ctx.forgotPassword();
        }
      });
    },
    forgotPassword() {
      this.loading = true;
      this.userProvider.forgotPassword(this.user.email)
        .then(() => {
          this.loading = false;
          this.showSuccessMsg('Reset password email sent to your email address');
        })
        .catch(() => {
          this.loading = false;
          this.showErrorMsg('This email is not associated with a Luminary account.');
        });
    },
    checkValidation() {
      this.$refs.forgotForm.validate((valid) => { this.form_valid = valid; });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

  .forgot-page {
    h4 {
      font-family: $clearface-bold;
      color: $black;
      font-size: 40px;
      letter-spacing: -1px;
      line-height: 44px;
      margin: 46px 0 8px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// app/src/pages/onboarding/ForgotPassword.vue